module.exports = __webpack_public_path__ + "img/efficiency2.88b8d43c.png";